export default [
    {
      title: "Promotion Management",
      customIcon: "CustomSVG",
      children: [
        {
          title: "Promotion List",
          route: "custom-module",
          path: "/custom-module/custom-promotion-list",
        },
      ],
    },
  ];
  